import { Tile } from 'ol/layer';
import { TileWMS } from 'ol/source';
import { AgroradMapLayer } from './custom-map-layer'

export class LayerH60B extends AgroradMapLayer {

    constructor() {
        super();
        this.id = 'h60b';
        this.caption = "Blended SEVIRI / LEO MW precipitation and morphologic information - MSG - 0 degree";
        this.zIndex = 10000;
        this.params = {
            SERVICE: "WMS",
            REQUEST:"GetMap",
            FORMAT:'image/png',
            TRANSPARENT:true,
            LAYERS:"msg_fes:h60b",
            VERSION: '1.1.0',
            tiled: true,
            WIDTH: 1024,
            HEIGHT: 1024,
            STYLES: '',
            TIME: new Date().toISOString()
        };
        this.layer = new Tile({
            visible: false,
            source: new TileWMS({
                url: 'https://agrorad.netfarm.it/eumetsat/geoserver/wms',
                //url: 'https://view.eumetsat.int/geoserver/wms',
                params: this.params
            }),
            zIndex: this.zIndex,
            // opacity: 0.8
        });
        this.visible=false;
    }
}
